import React, { Component } from 'react';
import { I18n } from 'react-i18next';
import Menu from "./menu";

export default class Section1 extends Component {
    render () {
        return (
            <I18n>
                {
                    (t, { i18n }) => (
                        <div className="section" id="section1">
                            <div className="s1-bg">
                                <Menu currentItem="home"/>
                                <div className="content-section-1">
                                    <div className="container">
                                        <div className="row">
                                            <div className="col-xs-12 col-sm-7 col-md-7 cs1-left">
                                                <h2 className="wow fadeInUp">{t('home_1')}</h2>
                                                <div className="cs1l-content wow fadeInUp" data-wow-delay="0.5s">
                                                    <p>{t('home_2')}</p>
                                                    <p>{t('home_3')}</p>
                                                    <p>{t('home_4')}</p>
                                                    <p>{t('home_5')}</p>
                                                    <p>{t('home_6')}</p>
                                                    <p>{t('home_7')}</p>
                                                    <p>{t('home_8')}</p>
                                                    <p>{t('home_9')}</p>
                                                </div>
                                            </div>
                                            <div className="cs1-right fadeInRight animated">
                                                <img src="/images/s1_5.png" className="s1r-spin" alt="" width={'95%'}/>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    )
                }
            </I18n>
        )
    }
}



// WEBPACK FOOTER //
// ./src/containers/section1.jsx